export default __webpack_public_path__ + "static/media/Q19_0_resized.3f7368ac.jpg";